import produce, { Draft } from 'immer';

import {
    AppContextState,
    AppContextAction,
    AppContextActions,
    ContextStatuses,
} from './types';

export const initialState: AppContextState = {
    memberGroup: null,
    advertiser: null,
    advertiserHasFunds: false,
    advertiserGroup: null,
    previousMemberGroupId: null,
    status: ContextStatuses.Idle,
    initialized: false,
    errorCode: null,
    memberGroupCurrencies: null,
    memberGroupBiddingConfigs: null,
    calculatedPageCurrency: null,
    savedReportTitle: null,
};

const appContextReducer = (
    state: AppContextState = initialState,
    action: AppContextActions
): AppContextState =>
    produce(state, (draft: Draft<AppContextState>) => {
        switch (action.type) {
            case AppContextAction.FETCH_CLIENT_CONTEXT:
            case AppContextAction.FETCH_EMBEDDED_APP_CONTEXT:
                draft.status = ContextStatuses.Pending;
                break;
            case AppContextAction.FETCH_ADVERTISER_GROUP_CONTEXT:
                draft.status = ContextStatuses.PendingAdvertiserGroup;
                break;
            case AppContextAction.FETCH_ADVERTISER_CONTEXT:
                draft.status = ContextStatuses.PendingAdvertiser;
                break;
            case AppContextAction.FETCH_APP_CONTEXT_SUCCESS:
                draft.status = ContextStatuses.Success;
                draft.memberGroup = action.payload.memberGroup;
                draft.advertiser = action.payload.advertiser;
                draft.advertiserGroup = action.payload.advertiserGroup;
                draft.initialized = true;
                break;
            case AppContextAction.FETCH_APP_CONTEXT_ERROR:
                draft.status = ContextStatuses.Error;
                draft.memberGroup = {
                    member_group_id: action.payload.memberGroupId,
                };
                draft.advertiser = action.payload.advertiserId
                    ? {
                          advertiser_id: action.payload.advertiserId,
                      }
                    : null;
                break;
            case AppContextAction.SET_PREVIOUS_MEMBER_GROUP:
                draft.previousMemberGroupId =
                    action.payload.previousMemberGroupId;
                break;
            case AppContextAction.SET_SAVED_REPORT_TITLE:
                draft.savedReportTitle = action.payload.savedReportTitle;
                break;
            case AppContextAction.SET_ERROR_CODE:
                draft.errorCode = action.payload.errorCode;
                break;
            case AppContextAction.CLEAR_CLIENT_CONTEXT:
                draft.memberGroup = null;
                draft.previousMemberGroupId = null;
                draft.savedReportTitle = null;
                break;
            case AppContextAction.CLEAR_ADVERTISER_CONTEXT:
                draft.advertiser = null;
                break;
            case AppContextAction.CLEAR_ADVERTISER_GROUP_CONTEXT:
                draft.advertiserGroup = null;
                break;
            case AppContextAction.SET_MEMBER_GROUP_CURRENCIES:
                draft.memberGroupCurrencies =
                    action.payload.memberGroupCurrencies;
                break;
            case AppContextAction.SET_MEMBER_GROUP_BIDDING_CONFIGS:
                draft.memberGroupBiddingConfigs = action.payload.biddingConfigs;
                break;
            case AppContextAction.SET_CALCULATED_PAGE_CURRENCY:
                draft.calculatedPageCurrency =
                    action.payload.calculatedPageCurrency;
                break;
            case AppContextAction.SET_ADVERTISER_HAS_FUNDS:
                draft.advertiserHasFunds = action.payload.hasFunds;
                break;

            case AppContextAction.SET_ADVERTISER_CONTENT:
                draft.advertiser = action.payload.advertiser;
                break;
            case AppContextAction.SET_CLIENT_CONTEXT:
                draft.memberGroup = action.payload.memberGroup;
                break;
            default:
                break;
        }
    });

export default appContextReducer;
